import { render, staticRenderFns } from "./OrderDetailDialog.vue?vue&type=template&id=4bb6639e&scoped=true"
import script from "./OrderDetailDialog.vue?vue&type=script&lang=js"
export * from "./OrderDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailDialog.vue?vue&type=style&index=0&id=4bb6639e&prod&scoped=true&lang=css"
import style1 from "./OrderDetailDialog.mobile.css?vue&type=style&index=1&id=4bb6639e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb6639e",
  null
  
)

export default component.exports